<template>
  <div>
    <el-tabs :tab-position="tabPosition" v-model="activeName" style="height: 100%; padding-top: 15px;">
      <el-tab-pane
        v-for="term in listTerm"
        :key="term.id"
        :label="term.name"
        :name="term.id">
        <div class="cell_height">
          <div class="cell_name">{{term.name}}</div>
          <el-button type="text" class="cell_chg_cel cell_chg" @click="chg_term">修改</el-button>/
          <el-button type="text" class="cell_chg_cel cell_del" @click="del_term">删除</el-button>
        </div>
        <div>
        <el-table
          :data="listTerm_one"
          border>
          <el-table-column prop="type" label="类型"></el-table-column>
          <el-table-column prop="deveui" label="终端串号"></el-table-column>
          <el-table-column prop="manu" label="终端厂商"></el-table-column>
          <el-table-column prop="product" label="终端产品"></el-table-column>
        </el-table>
        </div>
        <div class="margin_top_table">
          <div class="cell_height cell_name">传感器</div>
          <el-table
            :data="listSensor"
            border>
            <el-table-column prop="num" label="序号"></el-table-column>
            <el-table-column prop="name" label="传感器名称"></el-table-column>
            <el-table-column prop="addr" label="地址标识"></el-table-column>
            <el-table-column prop="product" label="产品名称"></el-table-column>
            <el-table-column fixed="right" label="操作">
              <template slot-scope="scope">
                <el-button type="text" size="small" @click="chg_sensor(scope.row)">编辑</el-button>
                <el-button type="text" size="small" class="sensor_del cell_chg_cel cell_del" @click="del_sensor(scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="margin_top_table">
          <div class="cell_height cell_name">设备</div>
          <el-table
            :data="listEquip"
            border>
            <el-table-column prop="num" label="序号"></el-table-column>
            <el-table-column prop="defname" label="设备名称"></el-table-column>
            <el-table-column prop="type" label="设备类型"></el-table-column>
            <el-table-column prop="addr" label="地址标识"></el-table-column>
            <el-table-column prop="road" label="第几路继电器"></el-table-column>
            <el-table-column fixed="right" label="设备启停">
              <template slot-scope="scope">
                <span>开</span>
                <el-switch
                  v-model="scope.row.status"
                  active-color="#13ce66"
                  inactive-color="#ff4949"
                  @change="changeStatus(scope.$index,scope.row)">
                </el-switch>
                <span>关</span>
              </template>
            </el-table-column>
            <el-table-column fixed="right" label="操作">
              <template slot-scope="scope" >
                <el-button type="text" size="small" @click="chg_equip(scope.row)">编辑</el-button>
                <el-button type="text" size="small" class="sensor_del cell_chg_cel cell_del"  @click="del_equip(scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-tab-pane>
    </el-tabs>
    <el-dialog :visible.sync="display_term" :before-close="handleClose">
      <div>
        <div class="addSensor_form">
          <el-form ref="form" :model="form" label-width="100px" class="demo-ruleForm">
            <el-form-item label="*终端名称">
              <el-input v-model="form.defTerm_name" placeholder="自定义"></el-input>
            </el-form-item>
            <el-form-item label="*终端串号">
              <el-input v-model="form.fixTerm_eui" placeholder="16个十六进制数"></el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="display_term = false">取 消</el-button>
        <el-button type="primary" @click="pre_term">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="display_sensor" :before-close="handleClose">
      <div>
        <div class="addSensor_form">
          <el-form ref="form" :model="form" label-width="120px" class="demo-ruleForm">
            <el-form-item label="*选择生产单元">
              <el-select v-model="form.cell_id" >
                <div v-for="cell in listCell" :key="cell.id">
                  <el-option :label="cell.name" :value="cell.id"></el-option>
                </div>
              </el-select>
            </el-form-item>
            <el-form-item label="*传感器名称">
              <el-input v-model="form.sensor_name" placeholder="自定义"></el-input>
            </el-form-item>
            <el-form-item label="*传感器地址标识">
              <el-input v-model="form.sensor_addr" placeholder="范围：1-255"></el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="display_sensor = false">取 消</el-button>
        <el-button type="primary" @click="pre_sensor">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="display_equip" :before-close="handleClose">
      <div>
        <div class="addSensor_form">
          <el-form ref="form" :model="form" label-width="105px" class="demo-ruleForm">
            <el-form-item label="*选择生产单元">
              <el-select v-model="form.pond_id" placeholder="请选择生产单元" >
                <div v-for="pond in listCell" :key="pond.id">
                  <el-option :label="pond.name" :value="pond.id"></el-option>
                </div>
              </el-select>
            </el-form-item>
            <el-form-item label="*设备名称">
              <el-input v-model="form.equip_name" placeholder="自定义"></el-input>
            </el-form-item>
            <el-form-item label="*终端id">
              <el-select v-model="form.equip_term_id" placeholder="请选择终端" >
                <div v-for="(term,index) in listTerm" :key="index">
                  <el-option :label="term.name" :value="term.id"></el-option>
                </div>
              </el-select>
            </el-form-item>
            <el-form-item label="*485地址">
              <el-input v-model="form.equip_addr" placeholder="范围：1-255"></el-input>
            </el-form-item>
            <el-form-item label="*第几路继电器">
              <el-input v-model="form.equip_road"></el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="display_equip = false">取 消</el-button>
        <el-button type="primary" @click="pre_equip">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data () {
    return {
      tabPosition: 'right',
      activeName: '',
      listCell: {},
      listTerm: {},
      listTerm_staus: [],
      listSensor: [],
      listEquip: [],
      display_term: false,
      display_sensor: false,
      display_equip: false,
      form: {
        defTerm_name: '', // 终端参数
        fixTerm_eui: '',
        cell_id: '', // 传感器参数
        sensor_name: '',
        sensor_addr: '',
        pond_id: '', // 设备参数
        equip_name: '',
        equip_term_id: '',
        equip_addr: '',
        equip_road: ''
      },
      token: window.sessionStorage.getItem('token'),
      username: window.sessionStorage.getItem('username'),
      sensorId: '',
      equip_id: '',
      user_id: ''
    }
  },
  methods: {
    // 获取 用户的所有生产单元
    getUserCells () {
      this.axios.get(this.$store.state.ip + 'celldef/listUserCells',
        {
          params: {'username': this.username},
          headers: {'Authorization': 'Bearer ' + this.token}
        }).then(res => {
        this.listCell = res.data.data.list
      }).catch(err => {
        console.log(err)
      })
    },
    // 获取 用户的所有终端
    getUserTerm () {
      this.axios.get(this.$store.state.ip + 'termdef/listTermsByUsr',
        {
          params: {'user_name': this.username},
          headers: {'Authorization': 'Bearer ' + this.token}
        }).then(res => {
        this.listTerm = res.data.data.list
        for (let i = 0; i < this.listTerm.length; i++) {
          this.listTerm[i].id = this.listTerm[i].id.toString()
        }
        this.activeName = this.listTerm[0].id
      }).catch(err => {
        console.log(err)
      })
    },
    // 获取 终端下的传感器
    getUsersSensors () {
      this.axios.get(this.$store.state.ip + 'sensordef/termSensors',
        {
          params: {'term_id': this.activeName},
          headers: {'Authorization': 'Bearer ' + this.token}
        }).then(res => {
        this.listSensor = res.data.data
        for (let i = 0; i < this.listSensor.length; i++) {
          this.listSensor[i].num = i + 1
          if (!(/^[a-z]+$/.test(this.listSensor[i].name[0]) || /^[A-Z]+$/.test(this.listSensor[i].name))) {
            this.listSensor[i].name = this.listSensor[i].name.split(/[a-z]/, 1).toString()
          }
        }
      }).catch(err => {
        console.log(err)
      })
    },
    // 获取 终端下的设备
    getUserEquips () {
      this.axios.get(this.$store.state.ip + 'equipdef/listTermEquip',
        {
          params: {'term_id': this.activeName},
          headers: {'Authorization': 'Bearer ' + this.token}
        }).then(res => {
        this.listEquip = res.data.data
        for (let i = 0; i < this.listEquip.length; i++) {
          this.listEquip[i].num = i + 1
          if (this.listEquip[i].status === 0) {
            this.listEquip[i].status = false
          } else {
            this.listEquip[i].status = true
          }
        }
      }).catch(err => {
        console.log(err)
      })
    },
    // 初始化 终端form
    chg_term () {
      this.display_term = true
      for (let i = 0; i < this.listTerm.length; i++) {
        if (this.listTerm[i].id === this.activeName) {
          this.form.defTerm_name = this.listTerm[i].name
          this.form.fixTerm_eui = this.listTerm[i].deveui
          break
        }
      }
    },
    // 初始化 传感器form
    chg_sensor (row) {
      this.getUserCells()
      this.display_sensor = true
      this.sensorId = row.id
      this.form.sensor_name = row.name
      this.form.sensor_addr = row.addr
      this.form.cell_id = row.cellid
    },
    // 初始化 设备form
    chg_equip (row) {
      this.display_equip = true
      this.getUserCells()
      this.equip_id = row.id
      this.form.pond_id = row.cellid
      this.form.equip_name = row.defname
      this.form.equip_addr = row.addr
      this.form.equip_road = row.road
      this.form.equip_term_id = this.activeName
    },
    // 删除 终端
    del_term () {
      this.$confirm('此操作将永久删除该终端, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.axios.delete(this.$store.state.ip + 'termdef/deleteTerm',
          {
            params: {'id': this.activeName},
            headers: {'Authorization': 'Bearer ' + this.token}
          }).then(res => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
          this.getUserCells()
        }).catch(err => {
          console.log(err)
        })
      }).catch(() => {
        this.$message({
          type: 'info'
        })
      })
    },
    // 删除 传感器
    del_sensor (row) {
      this.$confirm('此操作将永久删除该传感器, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.axios.delete(this.$store.state.ip + 'sensordef/deleteSensor',
          {
            params: {'sid': row.id},
            headers: {'Authorization': 'Bearer ' + this.token}
          }).then(res => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
          this.getUsersSensors()
        }).catch(err => {
          console.log(err)
        })
      }).catch(() => {
        this.$message({
          type: 'info'
        })
      })
    },
    // 删除 设备
    del_equip (row) {
      this.$confirm('此操作将永久删除该设备, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.axios.delete(this.$store.state.ip + 'equipdef/delEquip',
          {
            params: {'id': row.id},
            headers: {'Authorization': 'Bearer ' + this.token}
          }).then(res => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
          this.getUserEquips()
        }).catch(err => {
          console.log(err)
        })
      }).catch(() => {
        this.$message({
          type: 'info'
        })
      })
    },
    // 更新 终端
    pre_term () {
      this.display_term = false
      let formdata = new FormData()
      formdata.append('id', this.activeName)
      formdata.append('deveui', this.form.fixTerm_eui)
      formdata.append('name', this.form.defTerm_name)
      formdata.append('user', this.username)
      this.axios.post(this.$store.state.ip + 'termdef/updateTerm', formdata, {headers: {'Authorization': 'Bearer ' + window.sessionStorage.getItem('token')}}).then(res => {
        this.$message.success('修改成功')
        this.getUserTerm()
        this.listTerm_one[0].deveui = this.form.fixTerm_eui
      }).catch(err => {
        console.log(err)
        this.$message.success('修改失败')
      })
    },
    // 更新 传感器
    pre_sensor () {
      this.display_sensor = false
      let formdata = new FormData()
      formdata.append('id', this.sensorId)
      formdata.append('cell_id', this.form.cell_id)
      formdata.append('addr', this.form.sensor_addr)
      formdata.append('sensor_name', this.form.sensor_name)
      formdata.append('user_name', this.username)
      this.axios.post(this.$store.state.ip + 'sensordef/updateSensor', formdata, {headers: {'Authorization': 'Bearer ' + this.token}}).then(res => {
        this.$message.success('修改成功')
        this.getUsersSensors()
      }).catch(err => {
        console.log(err)
        this.$message.success('修改失败')
      })
    },
    // 更新 设备
    pre_equip () {
      this.display_equip = false
      let formdata = new FormData()
      formdata.append('id', this.equip_id)
      formdata.append('cell_id', this.form.pond_id)
      formdata.append('equip_name', this.form.equip_name)
      formdata.append('term_id', this.form.equip_term_id)
      formdata.append('addr', this.form.equip_addr)
      formdata.append('road', this.form.equip_road)
      this.axios.post(this.$store.state.ip + 'equipdef/updateEquip', formdata, {headers: {'Authorization': 'Bearer ' + this.token}}).then(res => {
        this.$message.success('修改成功')
        this.getUserEquips()
      }).catch(err => {
        console.log(err)
        this.$message.success('修改失败')
      })
    },
    // 弹窗
    handleClose (done) {
      this.$confirm('确定关闭吗').then(() => {
        // function(done)，done 用于关闭 Dialog
        done()
      }).catch(() => {
      })
    },
    // 更改设备状态
    changeStatus (index, row) {
      // 获取用户信息，取id
      this.axios.get(this.$store.state.ip + 'user/user/one',
        {
          headers: {'Authorization': 'Bearer ' + window.sessionStorage.getItem('token')}
        }).then(res => {
        this.user_id = res.data.data.id
      })
      let status2 = 0
      if (row.status === true) {
        status2 = 1
      }
      let formdata = new FormData()
      formdata.append('appusrid', this.user_id)
      formdata.append('equip_id', row.id)
      formdata.append('ison_fg', status2)
      this.axios.post(this.$store.state.ip + 'opt/control', formdata, {headers: {'Authorization': 'Bearer ' + this.token}}).then(res => {
        this.$message.success('修改成功')
      }).catch(err => {
        console.log(err)
        this.$message.warning('修改失败')
      })
    }
  },
  created () {
    this.getUserTerm()
  },
  watch: {
    'activeName': function () {
      this.listTerm_one = []
      for (let i = 0; i < this.listTerm.length; i++) {
        if (this.listTerm[i].id === this.activeName) {
          this.listTerm_one.push(this.listTerm[i])
          break
        }
      }
      this.getUsersSensors()
      this.getUserEquips()
    }
  }
}
</script>

<style scoped>
  .cell_height {
    text-align: left;
    margin-bottom: 10px;
    display: flex;
    align-items: center;
  }
  .cell_name {
    color: #333;
    font-size: 18px;
    font-weight: bold;
  }
  .cell_chg_cel {
    font-size: 12px;
    font-weight: bold;
    cursor: pointer;
  }
  .cell_chg {
    color: #409EFF;
    margin-left: 10px;
    margin-right: 5px;
  }
  .cell_del{
    color: #F56C6C;
    margin-left: 5px;
  }
  .margin_top_table {
    margin-top: 20px;
  }
  .addSensor_form {
    width: 400px;
    margin-left: 20px;
    margin-top: 30px;
  }
  .el-input, .el-select {
    margin-left: 10px;
    width: 300px;
  }
  .sensor_del {
    font-weight: normal;
  }
</style>



// WEBPACK FOOTER //
// src/components/control/term.vue